import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'vit-number',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss']
})
export class NumberComponent implements OnInit {
  @HostBinding('class.rollIn') rollIn = false;

  @Input()
  public animate: boolean = false;

  @Input()
  public color: string = '#207EA9';

  constructor() {
  }

  ngOnInit() {
    if (this.animate) {
      setTimeout(() => this.rollIn = true, 200);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/number/number.component.ts